import { DEFAULT_ORDER, gatewayBlocksUrl, PAGE_SIZE } from '../const'
import { GatewayListLoadPayload, GatewayListRequest } from './types'

export const buildGatewaysQuery = ({
  gatewayId,
  internalName,
  processingProvider,
  paymentMethodType,
  status,
  sorterField = DEFAULT_ORDER,
  page = '1',
  pageSize = String(PAGE_SIZE),
}: GatewayListRequest): Record<string, string> => {
  const where: Record<string, string | boolean> = {}

  if (gatewayId) where.gatewayId = gatewayId
  if (internalName) where.internalName = internalName
  if (processingProvider) where.processingProvider = processingProvider
  if (paymentMethodType) where.paymentMethodType = paymentMethodType
  if (status === 'blocked') where.isBlocked = true
  if (status === 'active') where.isBlocked = false

  const query: Record<string, string> = {
    page,
    limit: pageSize,
    order: sorterField,
  }

  if (Object.keys(where).length > 0) query.where = JSON.stringify(where)

  return query
}

// Shared by the initial load and by the refetch after a status change, so the
// two can never drift apart.
export const toGatewaysRequest = ({
  clientId,
  ...request
}: GatewayListLoadPayload) => ({
  url: gatewayBlocksUrl(clientId),
  query: buildGatewaysQuery(request),
})
